module.exports = "/images/add-plus-icon.svg?d87b9e65a3b0d45b9b30040eff8708ba";